import type { Tab } from '@/components/loop-dashboard/types/tabs';
import { Tab as TabEnum } from '@/components/loop-dashboard/types/tabs';
import { OriginView, type OriginViewValueType } from '../Avo';

export const getOriginView = (currentTab: Tab): OriginViewValueType => {
  switch (currentTab) {
    case TabEnum.Deliverables:
      return OriginView.DELIVERABLES;
    default:
      return OriginView.DELIVERABLES;
  }
};
